
import { Vue, Component, Prop } from "vue-property-decorator";

import TickIcon from "@/components/icons/TickIcon.vue";
import Cross from "@/components/icons/Cross.vue";
import Download from "@/components/icons/DownloadIcon.vue";
import UiButton from "@/components/button/ui-button.vue";
import CompleteIcon from "@/components/icons/Checkmark.vue";
import CheckMarkBlack from "@/components/icons/CheckMarkBlack.vue";
import DownloadIcon from "@/components/icons/DownloadBlack.vue";

@Component({
  components: {
    TickIcon,
    Cross,
    Download,
    UiButton,
    CompleteIcon,
    CheckMarkBlack,
    DownloadIcon,
  },
})
export default class Tabs extends Vue {
  @Prop({ type: Array, required: true }) tabs!: Array<{
    name: string;
    badge?: number;
  }>;
  @Prop({ type: Number, default: 0 }) activeTab!: number;
  @Prop({ default: () => [] }) readonly selectedRows: number[];
  @Prop({ default: () => [] }) readonly downloadAllTimesheets: number[];

  @Prop({ type: Boolean, default: false }) isAdmin: number;

  @Prop({ type: Boolean, default: false }) hiddenApprove: boolean;
  @Prop({ type: Boolean, default: false }) hiddenReject: boolean;
  @Prop({ type: Boolean, default: false }) hiddenDownload: boolean;
  @Prop({ type: String, default: '', required: false }) readonly tabClasses: string;

  setActiveTab(index: number) {
    this.activeTab = index;
    this.$emit("update:activeTab", index);
  }
  approveSelected() {
    this.$emit("approve-selected", this.selectedRows);
  }

  rejectSelected() {
    this.$emit("reject-selected", this.selectedRows);
  }
  downloadSelected() {
    this.$emit("download-selected", this.selectedRows);
  }
  downloadAllCSv() {
    this.$emit("download-all");
  }
}
